import { intCol, strCol } from '@integec/grid-tools/lib/cols'
import {
  YNBooleanTypes,
  modifiedDateCol,
  modifierCol,
} from 'core/HeaderColTypeProps'
import React, { useState } from 'react'
import CommonScreen from './CommonScreen'
import { Button, Input, Select } from 'antd'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

import {
  DayMap,
  DayMapSelectionChoiceMap,

  // HOURS,
  // HOURS_CHOICES,
} from 'core'
import R from 'ramda'
import {
  deletePeakDefinition,
  getPeakDefinition,
  postPeakDefinition,
} from 'admin/adminapi'
import { Label } from 'core/screen-util'

const PeakDefinition = _ => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '100px 200px 100px 150px 100px 150px 100px 150px auto',
          gap: 5,
        }}
      >
        <Label>Schedule :</Label>
        <Input
          value={insertData.schedule}
          onChange={e =>
            setInsertData({ ...insertData, schedule: e.target.value })
          }
        />

        <Label>Start Day : </Label>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.startday}
            onChange={val => setInsertData({ ...insertData, startday: val })}
          >
            {Object.keys(DayMap).map(k => (
              <Select.Option key={k} value={k}>
                {DayMap[k]}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Label>End Day : </Label>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.endday}
            onChange={val => setInsertData({ ...insertData, endday: val })}
          >
            {Object.keys(DayMap).map(k => (
              <Select.Option key={k} value={k}>
                {DayMap[k]}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Label>Holiday :</Label>
        <Select
          value={insertData.holiday}
          onChange={e => setInsertData({ ...insertData, holiday: e })}
        >
          <Select.Option value="Y">Yes</Select.Option>
          <Select.Option value="N">No</Select.Option>
        </Select>
        <div />

        <Label>Start Hour : </Label>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.starthour}
            onChange={val => setInsertData({ ...insertData, starthour: val })}
          >
            {R.range(1, 25).map(k => (
              <Select.Option key={k} value={k}>
                {k}
              </Select.Option>
            ))}
          </Select>
        </div>

        <Label>End Hour : </Label>
        <div>
          <Select
            style={{ width: '100%' }}
            value={insertData.endhour}
            onChange={val => setInsertData({ ...insertData, endhour: val })}
          >
            {R.range(1, 25).map(k => (
              <Select.Option key={k} value={k}>
                {k}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div />
        <div style={{ gridColumnEnd: 'span 3' }}>
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>

          <Button
            type="primary"
            onClick={() => onAdd(false)}
            style={{ marginLeft: '20px' }}
          >
            Add & Hide
          </Button>
          <Button
            type="danger"
            onClick={onCancel}
            style={{ marginLeft: '20px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  return (
    <CommonScreen
      isAdminScreen={false}
      title="Peak Definition"
      header={PeakDefinitionHeaders}
      saveTask={postPeakDefinition}
      retrieveTask={getPeakDefinition}
      deleteTask={deletePeakDefinition}
      altBy={d => d.schedule}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      sortOptions={[
        strCol({ ident: 'schedule', display: 'Schedule', sortOrder: 'asc' }),
      ]}
      defaultInsertData={{ holiday: 'N' }}
      // widthOffset={550}
      // heightOffset={100}
    />
  )
}

export default PeakDefinition

const PeakDefinitionHeaders = [
  strCol({ ident: 'schedule', display: 'Schedule', isKey: true, width: 250 }),
  intCol({
    ident: 'startday',
    display: 'Start Day',
    isRequired: true,
    width: 150,
    ...toSelectionColProps(DayMapSelectionChoiceMap),
  }),
  intCol({
    ident: 'endday',
    display: 'End Day',
    isRequired: true,
    width: 150,
    ...toSelectionColProps(DayMapSelectionChoiceMap),
  }),
  intCol({
    ident: 'starthour',
    display: 'Start Hour',
    isRequired: true,
    width: 150,
  }),
  intCol({
    ident: 'endhour',
    display: 'End Hour',
    isRequired: true,
    width: 150,
  }),
  strCol({
    ident: 'holiday',
    display: 'Holiday',
    isRequired: true,
    width: 150,
    ...toSelectionColProps(YNBooleanTypes),
  }),
  modifierCol,
  modifiedDateCol,
]
